import React from 'react';
import { useVr } from '../vr/VrContext';
import './VrToolbar.css';

export default function VrToolbar() {
  const { vrSafe, setVrSafe, gazeActive, setGazeActive, dwellProgress, rotate180, toggleRotate180, immersive, setImmersive } = useVr();
  return (
    <div className="vr-toolbar-global">
      <label className="vr-toggle">
        <input type="checkbox" checked={vrSafe} onChange={(e)=>setVrSafe(e.target.checked)} />
        <span>VR seguro</span>
      </label>
      <label className="vr-toggle">
        <input type="checkbox" checked={gazeActive} onChange={(e)=>setGazeActive(e.target.checked)} />
        <span>Selección por mirada</span>
      </label>
      <label className="vr-toggle">
        <input type="checkbox" checked={rotate180} onChange={toggleRotate180} />
        <span>VR 180°</span>
      </label>
      <label className="vr-toggle">
        <input type="checkbox" checked={immersive} onChange={(e)=>setImmersive(e.target.checked)} />
        <span>Inmersivo</span>
      </label>
      {gazeActive && (
        <div className="vr-dwell">
          <div className="vr-dwell-bar" style={{ width: `${dwellProgress}%` }} />
        </div>
      )}
    </div>
  );
}
